import React from 'react';
import {useInspectionStatusContext} from '../InspectionStatusContext';
import StatusBadge from '../../../_common/components/StatusBadge';

const InspectionStatus = () => {
  const {onChangeStatus, status, onSubmit} = useInspectionStatusContext();

  return Boolean(status.value) && (
    <StatusBadge
      status={status}
      onChange={onChangeStatus}
      onSubmit={onSubmit}
    />
  );
};

export default InspectionStatus;
